/* eslint-disable @typescript-eslint/no-explicit-any */
export default {
	name: 'pageHeader',
	title: 'Page Header',
	type: 'object',
	fields: [
		{
			name: 'title',
			title: 'Header Title',
			type: 'string',
			validation: (Rule: any) => Rule.required(),
		},
		{
			name: 'subtitle',
			title: 'Header Subtitle',
			type: 'text',
		},
		{
			name: 'description',
			title: 'Header Description',
			type: 'array',
			of: [{ type: 'block' }],
		},
		{
			name: 'backgroundImage',
			title: 'Background Image',
			type: 'image',
			options: {
				hotspot: true,
			},
			validation: (Rule: any) => Rule.required(),
		},
		{
			name: 'overlayOpacity',
			title: 'Background Overlay Opacity',
			description: 'Value between 0 (transparent) and 100 (opaque)',
			type: 'number',
			validation: (Rule: any) => Rule.min(0).max(100),
			initialValue: 50,
		},
	],
};
